module.exports = __webpack_public_path__ + "media/npc_dota_hero_troll_warlord.7c2a4a40.webm";